import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const AdGridHolder = styled.div`
  &.grid-view {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
  }

  &.list-view {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &.table-view {
    .cell-thumb-name {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
      cursor: pointer;

      .row-thumb {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        object-fit: cover;
        flex-shrink: 0;
      }

      .row-thumb.placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${Colors.background};
        color: ${Colors.primaryAccent};
      }

      .row-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${Colors.textStrong};
      }
    }
  }
`

export default AdGridHolder
